import { POC_Cloud_CONSTANTS } from "./constants";
import CardsList from "@/components/cardsList";

const PocCloudCards = () => {
  const { title, desc, list } = POC_Cloud_CONSTANTS;
  return (
    <CardsList
      columns={{ base: 1, sm: 2, md: 4 }}
      desc={desc}
      list={list}
      spacing={{ base: 8, md: 12 }}
      title={title}
    />
  );
};

export default PocCloudCards;
